import { IStyleConfig, mergeStyles } from '@cian/utils';
import * as React from 'react';

import { formatPhone } from '../../utils/helpers';

interface IPhoneProps {
  phone: string;
  style?: IStyleConfig;
}

export const Phone = ({ phone, style }: IPhoneProps) => <div {...mergeStyles(style)}>{formatPhone(phone)}</div>;
